import { companyInfo } from '../data/siteData';

export default function Logo({ inverted = false, className = 'h-14 sm:h-16 w-auto' }) {
  return (
    <img
      src={companyInfo.logoUrl}
      alt={companyInfo.name}
      className={`object-contain object-left transition duration-500 ${className} ${
        inverted ? 'brightness-0 invert' : ''
      }`}
    />
  );
}
